$(document).ready(function(){
  
  var form = $('.ajaxForm');

  form.on('submit', function(e) {
    e.preventDefault();

    var data = $(this).serialize();
    var honeypot = $('input#q').val();

    // -- Remove any existing error messages from previous attempts --
    $('html, body').animate({scrollTop: $('#body').offset().top}, 'slow');
    $('.form__notifications .success, .form__notifications .error').fadeOut();

    $.ajax({
      type: 'post',
      url: '/',
      dataType: 'json',
      data: data,
      beforeSend: function(response) {
        form.find('input[type=submit]').prop('disabled', true);
      },
      success: function(response) {
        console.log('ajax success');
        console.log(response);
        if (response.success && honeypot == '') {
          console.log('response success');
          // -- Display notifications --
          form.delay(300).fadeOut();
          $('.form__notifications .success').delay(600).fadeIn();

        } else {
          console.log('response error');
          // -- Display notifications --
          $('.form__notifications .error').delay(600).fadeIn();
        }
      },
      error: function(response) {
        console.log('ajax error');
        $('.form__notifications .error').delay(600).fadeIn();
      },
      complete: function(response) {
        form.find('input[type=submit]').prop('disabled', false);
      }
    });

  });

});
